<template>
  <!-- 待付款详情页面 -->
  <div class="content">
    <div class="header">
      <van-nav-bar title="订单详情" left-arrow @click-left="$router.back()" />
    </div>
    <div class="orderStatus">
      <img src="../../assets/img/icon/组 7511@2x.png" alt="" />
      <h4>待支付</h4>
      <div class="ToBePaidMoney">
        <span>需付：¥{{ Number(money).toFixed(2) }}</span>
        <div class="orderTime">
          <span>剩余</span>
          <van-count-down
            :time="orderTime"
            @finish="finish"
            format="HH时mm分ss秒"
          />
        </div>
      </div>
    </div>
    <div
      class="Logistics"
      @click="
        $router.push({
          path: '/Logistics',
          query: { orderCode: order_code },
        })
      "
      v-if="contextShow == true"
    >
      <van-steps direction="vertical" :active="0">
        <van-step>
          <p class="LogisticsInfo">{{ context }}</p>
          <van-icon name="arrow" />
          <p class="LogisticsTime">{{ fstime }}</p>
        </van-step>
      </van-steps>
    </div>
    <div
      class="Logistics"
      @click="$toast('已经是最新动态啦~')"
      v-if="contextShow == false"
    >
      <van-steps direction="vertical" :active="0">
        <van-step>
          <p class="LogisticsInfo">订单提交成功，请尽快完成付款！</p>
          <van-icon name="arrow" />
          <p class="LogisticsTime">{{ fstime }}</p>
        </van-step>
      </van-steps>
    </div>
    <div class="address">
      <div class="mobile">
        <span class="nameLeft">收件人：{{ this.AddressList.consignee }}</span>
        <span class="mobileRight">{{ mobile }} </span>
      </div>
      <p>{{ this.AddressList.address_str }}</p>
      <div class="modify" v-if="this.AddressList.is_update == '0'">
        <van-button
          @click="
            $router.push({
              path: '/orderEditAddress',
              query: { id: addressId },
            })
          "
          >修改</van-button
        >
      </div>
    </div>
    <div class="product">
      <van-card
        v-for="item in productList"
        :key="item.id"
        :num="'共' + item.num + '件'"
        :price="Number(item.oldPrice).toFixed(2)"
        :desc="item.color_name"
        :title="item.goods_detail_name"
        :thumb="item.color_img"
        @click="toShopping(item.goods_id)"
      >
        <template #num>
          <span>{{ "共" + item.num + "件" }}</span>
        </template>
      </van-card>
      <van-field
        v-if="this.LeavingAMessage != ''"
        v-model="LeavingAMessage"
        rows="2"
        autosize
        label="买家留言"
        type="textarea"
        show-word-limit
        disabled
      />
    </div>
    <div class="preferential">
      <van-cell-group class="info">
        <van-cell title="订单编号" :value="this.order_code" />
        <van-cell title="下单时间" :value="this.time" />
      </van-cell-group>
    </div>
    <div class="productMoney">
      <van-cell-group class="info">
        <van-cell
          title="商品金额"
          class="money"
          :value="'￥' + Number(this.money).toFixed(2)"
        />
        <van-cell title="运费" value="￥0" />
        <van-cell title="优惠券" value="暂无可用" />
      </van-cell-group>
    </div>
    <div class="btnBox" v-show="btnShow">
      <van-button
        @click="toCancelPayment()"
        color="#666666"
        size="small"
        plain
        round
        >取消订单</van-button
      >
      <van-button
        class="evaluate"
        @click="toPayment"
        color="#939393"
        size="small"
        plain
        round
        >去支付</van-button
      >
    </div>
    <van-loading
      color="#1989fa"
      size="1rem"
      vertical
      v-show="LoadingShow"
      type="spinner"
    />
  </div>
</template>
<script>
export default {
  data() {
    return {
      context: "",
      fstime: "",
      contextShow: false,
      LoadingShow: false,
      show: false,
      btnShow: true,
      title: "商品待发货",
      radio: "1",
      messages: "",
      AddressList: {},
      AddressShow: false,
      productList: {},
      order_code: "",
      money: "",
      LogisticsInfo: {},
      time: "",
      mobile: "",
      LeavingAMessage: "",
      orderTime: "10000",
    };
  },
  created() {
    this.getAddressList();
  },
  mounted() {
    this.getLogistics();
  },
  methods: {
    finish() {
      this.$toast("订单超时未支付，系统自动帮您取消!");
      this.$router.back();
    },
    async toPayment() {
      await this.$post({
        url: "oor/findOrderDetailByOrderCode",
        method: "get",
        params: {
          orderCode: this.order_code,
        },
      })
        .then((res) => {
          if (res.retCode == 200) {
            let flag = true;
            res.data.orderDetail.forEach((item) => {
              if (item.goodsStatus != 1) {
                return (flag = false);
              }
            });
            if (flag) {
              sessionStorage.setItem("PRODUCT_NUMBER", res.data.record_code);
              this.$router.push({
                path: "/payment",
                query: {
                  m: res.data.money,
                },
              });
            } else {
              this.$toast("商品已下架");
            }
          }
        })
        .catch((err) => {
          console.log(err);
        });
    },
    // 获取地址及商品信息
    async getAddressList() {
      let orderCode = this.$route.query.orderCode;
      this.title = this.$route.query.statusName;
      await this.$post({
        url: "oor/findOrderDetailByOrderCode",
        method: "get",
        params: {
          orderCode,
        },
      })
        .then((res) => {
          if (res.retCode == 200) {
            this.orderTime = res.data.remainTime;
            this.LeavingAMessage = res.data.orderDetail[0].remark;
            this.AddressList = res.data.addressInfo;
            this.addressId = res.data.address_id;
            this.mobile = this.AddressList.mobile.replace(
              this.AddressList.mobile.substr(3, 4),
              "****"
            );
            this.order_code = res.data.orderDetail[0].record_code;
            this.money = res.data.accountMoney;
            this.time = res.data.add_time;
            this.productList = res.data.orderDetail;
          }
        })
        .catch((err) => {
          return;
        });
    },
    // 获取物流信息
    async getLogistics() {
      let orderCode = this.$route.query.orderCode;
      await this.$post({
        url: "/oor/findLOGByCode",
        method: "get",
        params: {
          recordCode: orderCode,
        },
      })
        .then((res) => {
          if (res.retCode == 200) {
            this.LoadingShow = false;
            if (res.data.data2 !== undefined) {
              let AcceptStation = res.data.data2.reverse();
              this.context = AcceptStation[0].AcceptStation;
              this.fstime = AcceptStation[0].AcceptTime;
              this.contextShow = true;
            } else {
              this.fstime = res.data.recordTime;
              this.context = res.data.message;
              this.contextShow = false;
            }
          } else {
            this.$toast(res.message);
          }
        })
        .catch((err) => {
          this.$toast("暂无物流信息");
        });
    },
    // 取消订单
    toCancelPayment() {
      let orderCode = this.$route.query.orderCode;
      this.$dialog
        .confirm({
          title: "取消订单",
          message: "您确认要取消订单吗？",
        })
        .then(() => {
          // on confirm
          this.$post({
            url: "/oor/shutOrder",
            method: "post",
            params: {
              recordCode: orderCode,
            },
          })
            .then((res) => {
              if (res.retCode == 200) {
                this.$toast("已取消");
                this.$router.replace({
                  path: "/DeliverGoods",
                  query: {
                    orderCode,
                    title: "订单已取消",
                  },
                });
              }
            })
            .catch((err) => {});
        })
        .catch(() => {
          // on cancel
        });
    },
    toShopping(id) {
      sessionStorage.setItem("P_ID", id);
      this.$router.push("/toShopping");
    },
  },
};
</script>
<style lang="less" scoped>
.content {
  width: 100%;
  position: relative;
  // background-color: #f9f9f9;
  padding-bottom: 0.5rem;
  padding-top: 1rem;
  .orderStatus {
    padding: 0.35rem 0.27rem;
    height: 3rem;
    padding-top: 0.6rem;
    background-color: #fff;
    box-sizing: border-box;
    text-align: center;
    img {
      width: 1rem;
      height: 1rem;
      vertical-align: middle;
    }
    h4 {
      font-size: 0.4rem;
      font-family: PingFang SC;
      display: inline-block;
    }
    .ToBePaidMoney {
      text-align: center;
      span {
        color: #f74b2e;
        font-weight: 600;
      }
      .orderTime {
        margin-top: 0.1rem;
        font-size: 0.37rem;
        span {
          display: inline-block;
          color: #333 !important;
        }
        .van-count-down {
          font-weight: 600;
          font-size: 0.37rem !important;
          color: #333 !important;
          display: inline-block;
        }
      }
    }
  }
  .header {
    width: 100%;
    position: fixed;
    top: 0;
    left: 0;
    z-index: 10;
    background-color: #ffffff;
    .van-nav-bar {
      background-color: #40000000;
      .van-nav-bar__text {
        color: #030303;
        font-size: 0.45rem;
      }
      /deep/.van-nav-bar__left {
        .van-icon {
          margin-top: 0.1rem;
          color: #030303;
          font-size: 0.533333rem;
        }
      }
      .van-nav-bar__title.van-ellipsis {
        font-weight: 500 !important;
      }
    }
  }
  .Logistics {
    width: 9.2rem;
    margin: 0 auto;
    border-radius: 3px;
    margin-top: 0.27rem;
    background-color: #fff;
    padding: 0.3rem 0 0.3rem 0;
    .van-icon {
      font-size: 0.43rem;
      float: right;
      color: #333;
    }
    .LogisticsInfo {
      width: 7.8rem;
      display: inline-block;
      color: #333;
    }
    .LogisticsTime {
      margin-top: 0.27rem;
      color: #666666;
    }
    .van-steps {
      padding-left: 0.27rem;
      /deep/.van-step__circle-container {
        .van-icon {
          //  position: static;
          display: none !important;
        }
      }
    }
  }
  .address {
    width: 9.2rem;
    margin: 0 auto;
    border-radius: 3px;
    margin-top: 0.27rem;
    background-color: #fff;
    padding-top: 0.53rem;
    .modify {
      width: 100%;
      height: 1rem;
      .van-button {
        padding: 0;
        margin-right: 0.37rem;
        float: right;
        width: 1.49rem;
        height: 0.72rem;
        border: 0.01rem solid #333333;
        opacity: 1;
        border-radius: 0.5rem;
      }
    }
    .mobile {
      padding: 0 0.27rem;
      overflow: hidden;
      font-size: 0.4rem;

      .nameLeft {
        float: left;
      }
      .mobileRight {
        position: relative;
        float: right;
        text-align: center;
        vertical-align: middle;
        color: #333;
        .van-icon {
          top: -0.04rem;
          font-size: 0.4rem;
          vertical-align: middle;
        }
      }
    }
    p {
      padding: 0.48rem 0.27rem;
      font-size: 0.4rem;
      color: #999999;
    }
    .addressInfo {
      padding: 0.3rem 0.27rem;
    }
  }
  .payFashion {
    width: 9.2rem;
    margin: 0 auto;
    border-radius: 3px;
    margin-top: 0.27rem;
    background-color: #fff;
    .van-radio-group {
      .van-cell-group {
        .van-cell.van-cell--clickable {
          position: static;
          border-bottom: none;
          img {
            width: 0.61rem;
            height: 0.61rem;
            margin-right: 0.27rem;
          }
        }
      }
    }
  }
  .product {
    width: 9.2rem;
    margin: 0 auto;
    border-radius: 3px;
    margin-top: 0.27rem;
    padding: 0.53rem 0;
    background-color: #fff;
    .van-card {
      background-color: #fff;
      padding: 0;
      .van-card__header {
        .van-card__content {
          margin-left: 0.87rem;
          .van-card__bottom {
            .van-card__price {
              color: #f74b2e;
              font-size: 0.37rem;
            }
            .van-card__num {
              color: #333;
              margin-right: 0.4rem;
            }
          }
          .van-card__title {
            font-size: 0.43rem;
            color: #333333;
            text-overflow: ellipsis;
            -webkit-line-clamp: 1;
            -webkit-box-orient: vertical;
          }
          .van-card__desc {
            width: 4.5rem;
            padding-top: 0.2rem;
            color: #666666;
          }
        }
        .van-card__thumb {
          /deep/img {
            margin-left: 0.27rem;
            display: block;
            // width: 2.88rem;
            // height: 2.24rem;
          }
        }
      }
      .van-card__footer {
        margin-top: 0.45rem;
        .van-cell {
          padding: 0;
          /deep/.van-field__label {
            width: 1.8rem;
            text-align-last: left;
          }
        }
      }
    }
    /deep/.van-cell {
      .van-cell__title {
        span {
          font-size: 0.37rem !important;
          color: #333333 !important;
        }
      }
    }
  }
  .preferential {
    width: 9.2rem;
    margin: 0 auto;
    border-radius: 3px;
    margin-top: 0.27rem;
    background-color: #fff;
    .van-cell__value {
      color: #333333;
    }
    .van-cell.van-cell--clickable.van-coupon-cell {
      position: static;
    }
    /deep/[class*="van-hairline"]::after {
      border: 0 solid #ffffff !important;
    }
  }
  .productMoney {
    width: 9.2rem;
    margin: 0 auto;
    border-radius: 3px;
    margin-top: 0.27rem;
    background-color: #fff;
    margin-bottom: 1rem;
    .van-cell__value {
      color: #333333;
    }
    .fare {
      .van-swipe-cell__wrapper {
        .van-cell {
          .van-cell__value {
            color: red;
          }
        }
      }
    }
  }
  .van-loading {
    z-index: 99;
    position: fixed;
    top: 53%;
    left: 50%;
    transform: translate(-50%);
  }
  .btnBox {
    position: fixed;
    bottom: 0;
    height: 1.2rem;
    width: 100%;
    background-color: #fff;
    display: flex;
    justify-content: flex-end;
    align-items: center;
    /deep/.van-button {
      height: 0.72rem;
      margin-right: 0.4rem;
      color: #666666 !important;
      border-color: #999999;
    }
    .evaluate {
      background-color: #f74b2e;
      border-color: #f74b2e !important;
      color: #fff !important;
    }
  }
}
</style>
